import React from "react";
import Link from "components/Link";
import "./Logo.css";

const Logo: React.FC = () => {
  const letters = [
    "D","é","v","e","l","o","p","p","e","u","r","\u00A0","W","e","b"
  ];

  return (
    <Link href="/">
      <div className="logo-perspective">
        <div className="animate-letters flex items-center">
          
          {/* Image à gauche avec taille fixe */}
          <img
            src="/images/logoBlanc.png"
            alt="Logo"
            className="animate-letter w-8 h-8 mr-2"
            style={{ animationDelay: "0s" }}
          />

          {/* Lettres */}
          {letters.map((letter, index) => (
            <span
              key={index}
              className="animate-letter"
              style={{ animationDelay: `${(index + 1) * 0.05}s` }}
            >
              {letter}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
};

export default Logo;
